// Breaking Page Skeleton - No anonymous functions
import { Box, Card, Container, Skeleton } from '@mui/material';

// Pre-computed arrays
const TAB_SKELETON_WIDTHS = [60, 80, 70, 75, 65, 70, 55, 75];
const MARKET_SKELETON_ITEMS = [1, 2, 3, 4];
const NEWS_SKELETON_ITEMS = [1, 2, 3, 4, 5];

// Extracted components
const TabSkeletonItem = ({ width }: { width: number }) => (
  <Skeleton variant="rounded" width={width} height={40} sx={{ borderRadius: 2 }} />
);

const MarketSkeletonItem = () => (
  <Card sx={{ p: { xs: 2, sm: 3 } }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, sm: 3 } }}>
      <Skeleton variant="text" width={30} height={40} />
      <Skeleton variant="rounded" width={50} height={50} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="90%" height={24} />
        <Skeleton variant="text" width="70%" height={20} />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Skeleton variant="text" width={60} height={40} />
        <Skeleton variant="text" width={50} height={30} />
      </Box>
      <Skeleton variant="circular" width={24} height={24} />
    </Box>
  </Card>
);

const NewsSkeletonItem = () => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.5 }}>
      <Skeleton variant="circular" width={8} height={8} sx={{ mt: 0.75 }} />
      <Skeleton variant="text" width="80%" height={20} />
    </Box>
    <Skeleton variant="text" width="95%" height={18} />
    <Skeleton variant="text" width="70%" height={18} sx={{ mb: 0.5 }} />
    <Skeleton variant="text" width={120} height={16} />
  </Box>
);

export const BreakingSkeleton = () => {
  const renderedTabSkeletons = TAB_SKELETON_WIDTHS.map((width, i) => (
    <TabSkeletonItem key={i} width={width} />
  ));

  const renderedMarketSkeletons = MARKET_SKELETON_ITEMS.map((item) => (
    <MarketSkeletonItem key={item} />
  ));

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3, md: 4 } }}>
      <Box sx={{ display: 'flex', gap: 3, flexDirection: 'column' }}>
        {/* Main Content */}
        <Box sx={{ flex: 1 }}>
          {/* Hero Section */}
          <Card
            sx={{
              p: { xs: 3, sm: 4 },
              mb: 3,
              borderRadius: 3,
            }}
          >
            <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="40%" height={48} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="60%" height={24} />
          </Card>

          {/* Category Tabs */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mb: 3,
              pb: 1,
              borderBottom: 1,
              borderColor: 'divider',
              overflowX: 'auto',
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
            }}
          >
            {renderedTabSkeletons}
          </Box>

          {/* Markets List */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {renderedMarketSkeletons}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default BreakingSkeleton;
